import axios from 'axios'
import md5 from './md5'

axios.defaults.baseURL = '/xdnphb/onlineApi/'

/**
 * 为了兼容以前的接口，返回加密后的参数
 */
const AppKey = 'joker'
function sortOptions(url, options) {
  const arr = []
  Object.entries(options).forEach(([key, value]) => {
    if (typeof value === 'object') {
      arr.push(key.trim())
    } else {
      arr.push(key.trim())
    }
  })
  arr.sort()
  const objParameter = {}
  let code = ''
  if (url.indexOf('http://') === 0) {
    code += url.slice(url.indexOf('/', 7)) + '?AppKey=' + AppKey
  } else if (url.indexOf('https://') === 0) {
    code += url.slice(url.indexOf('/', 8)) + '?AppKey=' + AppKey
  } else {
    code = url + '?AppKey=' + AppKey
  }

  arr.forEach(function(item) {
    objParameter[item] = options[item]
    code += '&' + item + '=' + options[item]
  })
  const nonce = setNonce()
  objParameter['nonce'] = nonce
  code += '&nonce=' + nonce
  objParameter['xyz'] = md5(code)
  return objParameter
}

function setNonce() {
  const data = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f'
  ]
  let result = ''
  for (let j = 0; j < 500; j++) {
    result = ''
    for (let i = 0; i < 9; i++) {
      let r = Math.floor(Math.random() * 16)
      result += data[r]
    }
  }
  return result
}

/**
 * 获取左侧列表
 *
 * @param {String} url 请求的接口名
 * @returns Promise
 */
export async function getInitMenu() {
  const data = await axios.get('initMenu')
  return data
}

/**
 * 保存文档一级和二级
 *
 * @param {String} url 接口名
 * @param {Object} params 请求参数
 * 二级 pa'rams = {
 * req_example: '', // 请求示例
  req_comment: '', // 请求注释
  res_comment: '', // 响应注释
  status_comment: '', // 状态码注释
  accept: 'application/json',
  content_type: 'application/x-www-form-urlencoded;charset=utf-8',
  visite_level: '0', // 接口访问级别
  visite_frequency: '10', // 访问频次
  name: '', // 接口名
  url: '', // 接口url
  parent_id: '', // 文档分类节点
  level: '2', // 二级节点
  method: 'POST', // 接口请求方法
  request_body: '', // 请求参数描述
  request_json: '', // 请求参数例子
  reponse_body: '', // 响应结果参数描述
  reponse_json: '', // 响应结果例子
  comments: '', // 其他
  desp: '', // 描述
  price_model: 价格类型1和2
  price: 价格
  status_collection: 状态码说明
 * }
 * @returns Promise
 */
export async function saveDocumentApi(params) {
  const res = await axios.post('saveMenu', params)
  return res
}

/**
 * 创建二级标题
 * POST /xdnphb/onlineApi/saveNoInfoMenu
 * @export
 * @param {Object} params {parentId, name, level}
 * @returns
 */
export async function ApiCreateTwoLevelTitle(params) {
  const res = await axios.post('saveNoInfoMenu', params)
  return res
}

// 获取接口文档信息
export async function getDocument(params) {
  const res = await axios.get('viewMenu', {
    params: params
  })
  return res
}

/**
 * 更新文档信息和标题
 *
 * @export
 * @param {any} url
 * @param {any} params
 * @returns
 */
export async function updateDocumentAndTitle(params) {
  const res = await axios.post('updateMenu', params)
  return res
}

// 删除左侧列表
export async function deleteMenu(params) {
  const res = await axios.delete('deleteMenu', {
    params: params
  })
  return res
}

// 发布文档
export async function publishMenu(params) {
  const res = await axios.put('publishMenu', params)
  return res
}

// 获取所有api
export function getApiList(url) {
  return axios.get(url)
}

// 获取登陆状态
export function get(url) {
  return axios.get(url)
}

export function openApiResult(url, params) {
  return axios.get(url, {
    params: params
  })
}

// 新统一支付
export function toPay(url, params) {
  return axios({
    baseURL: '/xdnphb/',
    method: 'post',
    url: url,
    transformRequest: [
      function(data, headers) {
        let stringifyStr = ''
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            if (data[key] !== undefined) {
              stringifyStr += key + '=' + data[key] + '&'
            }
          }
        }
        return stringifyStr.slice(0, -1)
      }
    ],
    // data: params
    data: sortOptions('/xdnphb/' + url, params)
  })
}


/** 退出登录 */
export function loginOut() {
  return axios({
    baseURL: '/nr',
    method: 'post',
    url: '/user/login/loginOut',
    transformRequest: [
      function(data, headers) {
        let stringifyStr = ''
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            if (data[key] !== undefined) {
              stringifyStr += key + '=' + data[key] + '&'
            }
          }
        }
        return stringifyStr.slice(0, -1)
      }
    ],
    data: sortOptions('/nr/user/login/loginOut', {})
  })
}

// 创建订单号
export function createApiOrder(url, params) {
  return axios.post(url, params)
}

// 跳转支付
export function toAlipay(url, params) {
  return axios({
    method: 'post',
    url: url,
    transformRequest: [
      function(data, headers) {
        let stringifyStr = ''
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            if (data[key] !== undefined) {
              stringifyStr += key + '=' + data[key] + '&'
            }
          }
        }
        return stringifyStr.slice(0, -1)
      }
    ],
    // data: params
    data: sortOptions(url, params)
  })
}

// 获取前台左侧列表
export function frontInitMenu(url) {
  return axios.get(url)
}

// 排序
export function updateSort(url, params) {
  return axios.post(url, params)
}

// 获取前台接口详情
export async function infrontViewMenu(params) {
  const res = axios.get('infrontViewMenu', {
    params: params
  })
  return res
}

/**
 * 获取api套餐信息
 *
 * @param {String} url 请求地址
 */
export function getApiPack(url) {
  return axios.get(url);
}

/**
 * 获取折扣
 *
 * @returns
 */
export function discount() {
  return axios.get('discount')
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/js/fetch.js